export default {
      id: "email-usage",
      viewBox: "0 0 20 19",
      url: __webpack_public_path__ + "sprite.svg#email",
      toString: function () {
        return this.url;
      }
    }